<template>
  <div class="clearfix seller wrap">
    <div class="pull-left bg-white menu">
      <!--:style="{height: `${type === '0' ? 670 : 720}px`}"-->
      <ul :style="{minHeight: `${type === '0' ? 670 : 720}px`}">
        <li>
          <router-link :to="`/manage?type=${type}`"
             class="cur">
            {{type === '0' ? '我的订单' : '首页'}}
          </router-link>
        </li>

        <li v-for="(item, index) in menuList"
          :key="index"
          :class="{child: item.child && item.child.length > 1}">
          <template v-if="item.child && item.child.length > 1">
            <span>{{item.name}}</span>
            <ul>
              <li v-for="(item2, index2) in item.child"
                  :key="`${index}-${index2}`">
                <a :href="item2.cAhref" target="_blank">{{item2.name}}</a>
              </li>
            </ul>
          </template>
          <!--:href="item.child[0].cAhref" target="_blank" -->
          <a v-else-if="item.child && item.child.length === 1"
             :href="item.child[0].cAhref" target="_blank">
            {{item.child[0].name}}
          </a>
          <!--:href="item.cAhref" target="_blank" -->
          <a v-else :href="item.cAhref" target="_blank">{{item.name}}</a>
        </li>
      </ul>
    </div>
    <!--:style="{height: `${type === '0' ? 850 : 1673}px`}"-->
    <div class="content" v-if="type === '0'" id="iframeHeight" :style="{height: `${conHeight}px`}">
      <iframe scrolling='no' frameborder='0' :src="iframeSrc" id="iframepage"/>
    </div>
    <div class="content" v-if="type === '1'" id="iframeHeight"  :style="{height: `${conHeight}px`}">
       <iframe scrolling="no" frameborder="0" :src="iframeSrc" id="iframepage"/>
       <!-- <promotioncreate></promotioncreate> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
import { mapState } from 'vuex';
// import menuhome from '../menucompont/home';// 首页
// import shopadmin from '../menucompont/shopadmin';// 店铺管理
// import navigation from '../menucompont/navigation';// 导航管理
// import homeFitment from '../menucompont/homeFitment';// 首页装修
// import kinds from '../menucompont/kinds';// 货品管理
// import discountcoupon from '../menucompont/discountcoupon';// 优惠券管理
// import promotion from '../menucompont/promotion';// 促销活动管理
// import promotioncreate from '../menucompont/promotion-create';// 促销活动管理
// import creatediscounts from '../menucompont/creatediscounts';// 创建优惠券
// import bill from '../menucompont/bill';// 对账单
import { buyer, seller } from './menu';
import {
  toCartInfo,
  toGoodInfo,
  toStoreInfo,
  toYynIndex,
  toOrder,
  updateTitle,
  toOrderPayment,
} from '../ifrMethord';

export default {
  components:{
    // promotioncreate
  },
  /* components: {
    menuhome,
    shopadmin,
    navigation,
    homeFitment,
    kinds,
  }, */
  data() {
    return {
      curName: '',
      isFirst: true,
      loginUrl: `/login?retUrl=${window.location.href}`,
      type: '0',
      menuList: [],
      iframeSrc: '', // order/person/orderList.do?yynid=1
      height: '',
      conHeight: '',
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo,
    portalDomain: state => state.app.portalDomain,
    enterpriseDefault: state => state.app.enterpriseDefault,
  }),
  watch: {
    $route() {
      window.location.reload(true);
    },
  },
  created() {
    const orgid = this.enterpriseDefault.ID || '';
    this.iframeSrc = `${process.env.VUE_APP_SC}order/person/orderList.do?yynid=${this.portalDomain.platType}`;
    buyer.forEach((item) => {
      item.cAhref = `${item.cAhref}${this.portalDomain.platType}`;
    });
    seller.forEach((item) => {
      item.cAhref = `${item.cAhref}${this.portalDomain.platType}`;
    });
    if (window.location.href.indexOf('nxin.com') !== -1) {
      document.domain = 'nxin.com';
    }
    // const { iplattwo } = this.portalDomain;
    const {
      query: {
        type,
      },
    } = this.$route;
    this.type = '1';
    // 是否登录
    if (!this.userInfo.id) {
      // const service = `${process.env.VUE_APP_SC}mj/order/manage/orderList.do`;
      window.location.href = this.loginUrl;
    }
    // const orgid = this.enterpriseDefault.ID;
    if (type === '1') { // mj/queryShopMJ.do?yynid=1 mj/index.do?yynid=1
      if (!orgid) {
        this.$router.push('/');
      }
      this.menuList = seller;
      this.iframeSrc = `${process.env.VUE_APP_SC}mj/index.do?yynid=${this.portalDomain.platType}`;
      /* if (orgid) {
        // 企业是否开店
        const platformtype = this.portalDomain.platType;
        this.$store.dispatch('app/getEnterIsOpenShop', {
          platformtype,
        }).then((response) => {
          const { data } = response;
          if (data.audit === 1) {
            this.$store.dispatch('app/getEnterpriseMenu', {
              iPlat: 2,
              enterpriseId: orgid,
              iEnteSortID: data.shopId,
              iplattwo,
            }).then((res) => {
              const enterpriseSeller = res.filter(item => item.name === '卖家中心');
              console.log(enterpriseSeller);
              if (enterpriseSeller.length) { // [0].child
                this.menuList = enterpriseSeller[0].child;
                // this.menuList = sellerFilter; // .splice(1, sellerFilter.length - 1)
              }
            });
          }
        });
      } else {
        // 个人是否开店
        this.$store.dispatch('app/getShop').then((data) => {
          if (data.audit === 1) {
            this.menuList = seller;
          }
        });
      } */
    }
    if (type === '0') {
      this.menuList = buyer;
      /* if (orgid) {
        this.$store.dispatch('app/getEnterpriseMenu', {
          iPlat: 2,
          enterpriseId: orgid,
          iplattwo,
        }).then((res) => {
          const enterpriseBuyer = res.filter(item => item.name === '买家中心');
          if (enterpriseBuyer.length) {
            const buyerFilter = enterpriseBuyer[0].child;
            buyerFilter.forEach((item) => {
              if (item.name !== '买家主页' && item.name !== '企业订单') {
                this.menuList.push(item);
              }
            });
            // this.menuList = buyerFilter.splice(2, buyerFilter.length - 1);
          }
        });
      } else {
        this.menuList = buyer;
      } */
    }
    console.log(this.menuList, 'menuListmenuListmenuListmenuList');
    /* window.onresize = () => {
      this.changeFrameHeight();
    }; */
  },
  mounted() {
    window.toGoodInfo = toGoodInfo;
    window.toStoreInfo = toStoreInfo;
    window.toCartInfo = toCartInfo;
    window.toYynIndex = toYynIndex;
    window.toOrder = toOrder;
    window.updateTitle = updateTitle;
    window.toOrderPayment = toOrderPayment;
    window.message = this.message;
    window.heightPx = this.heightPx;
    // eslint-disable-next-line
    const _this = this;
    /* window.onresize = () => {
      _this.changeFrameHeight();
    }; */
    const iframe = document.getElementById('iframepage');
    iframe.onload = () => {
      this.changeFrameHeight();
    };
  },
  methods: {
    heightPx(high) {
      this.conHeight = high;
    },
    message(text) {
      this.$msgbox(text, '提示', {
        confirmButtonText: '确定',
      });
    },
    openIframe(item) {
      this.isFirst = false;
      this.curName = item.name;
      this.iframeSrc = item.cAhref;
    },
    openIframe1(item) {
      this.isFirst = false;
      this.curName = item.name;
      this.curName = item.child[0].name;
      this.iframeSrc = item.child[0].cAhref;
    },
    changeFrameHeight() {
      const iframe = document.getElementById('iframepage');
      try {
        if (iframe.attachEvent) {
          iframe.attachEvent('onload', () => {
            iframe.height = iframe.contentWindow.document.documentElement.scrollHeight;
            console.log(iframe.height);
          });
        } else {
          iframe.onload = () => {
            iframe.height = iframe.contentDocument.body.scrollHeight;
            console.log(iframe.height);
          };
        }
      } catch (e) {
        throw new Error('setIframeHeight Error');
      }
    },
  },
};
</script>
